<div id="angularRoot">
  <div fxLayout="row" fxLayoutWrap="fxLayoutWrap" fxShow="true" fxHide="false" id="7618b0b0-475a-96dc-af1e-d0a35a462f8e" fxFill="fxFill">
    <div fxLayout="column" id="40b0eb63-6dab-3ce1-b89d-152a16704fe3" fxFill="fxFill" *ngIf="chartsData &amp;&amp; chartsData.byProduct" fxFlex.xs="1 0 100" fxFlex.gt-xs="48" ngClass.xs="display-block">
      <bh-vscharts fxFill="" [chartData]="chartsData?.byProduct" chartTitle="Products" chartYAxisLabel="Performance" chartXAxisLabel="Importance" [yMax]="chartsData?.byProduct?.yMax" [yMin]="chartsData?.byProduct?.yMin"></bh-vscharts>
    </div>
    <div fxLayout="column" id="80a908d4-5059-26af-3201-41699b49db3a" *ngIf="chartsData &amp;&amp; chartsData.byCategory" fxFlex.xs="1 0 100" fxFlex.gt-xs="48" fxFill="fxFill">
      <bh-vscharts fxFill="" [chartData]="chartsData?.byCategory" chartTitle="Categories" chartYAxisLabel="Performance" chartXAxisLabel="Importance" [yMax]="chartsData?.byCategory?.yMax" [yMin]="chartsData?.byCategory?.yMin"></bh-vscharts>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/missioncontrolComponent/missioncontrol.template.html